import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const BulletList = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle cx='4.5' cy='4.75' r='1' fill='currentColor' />
        <path
          d='M8.91797 4.88879H19.7537'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='4.5' cy='11.8607' r='1' fill='currentColor' />
        <path
          d='M8.91797 11.9995H19.7537'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <circle cx='4.5' cy='18.9725' r='1' fill='currentColor' />
        <path
          d='M8.91797 19.1113H19.7537'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <circle cx='4.5' cy='4.75' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.01465 4.88887C8.01465 4.39796 8.41892 4 8.91762 4H19.7533C20.252 4 20.6563 4.39796 20.6563 4.88887C20.6563 5.37978 20.252 5.77773 19.7533 5.77773H8.91762C8.41892 5.77773 8.01465 5.37978 8.01465 4.88887Z'
          fill='currentColor'
        />
        <circle cx='4.5' cy='11.8607' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.01465 11.9996C8.01465 11.5087 8.41892 11.1107 8.91762 11.1107H19.7533C20.252 11.1107 20.6563 11.5087 20.6563 11.9996C20.6563 12.4905 20.252 12.8885 19.7533 12.8885H8.91762C8.41892 12.8885 8.01465 12.4905 8.01465 11.9996Z'
          fill='currentColor'
        />
        <circle cx='4.5' cy='18.9725' r='1' fill='currentColor' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.01465 19.1114C8.01465 18.6205 8.41892 18.2225 8.91762 18.2225H19.7533C20.252 18.2225 20.6563 18.6205 20.6563 19.1114C20.6563 19.6023 20.252 20.0003 19.7533 20.0003H8.91762C8.41892 20.0003 8.01465 19.6023 8.01465 19.1114Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
